<ion-searchbar
  color="light"
  placeholder="Address/City/State/Zip"
  (ionClear)="searchBarClear()"
  [value]="searchText$ | async"
  search-icon="/assets/svg/property-search-active.svg"
></ion-searchbar>
